"use strict";
'kiwi public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
let Vue = require('vue');
var _default = exports.default = Vue.component('input-prompt', {
  props: ['label', 'hideCancel', 'block'],
  data() {
    return {
      value: '',
      state: 'pre',
      waiting: false
    };
  },
  computed: {
    hasChildren() {
      return !!this.$slots.default;
    }
  },
  created() {
    if (!this.hasChildren) {
      this.prompt();
    }
  },
  methods: {
    prompt() {
      this.state = 'prompt';
      this.$nextTick(() => {
        this.$el.querySelector('input').focus();
      });
    },
    complete() {
      if (this.waiting) {
        return;
      }
      if (this.hasChildren) {
        this.state = 'pre';
      } else {
        this.waiting = true;
      }
      const doneWaiting = () => {
        this.waiting = false;
      };
      this.$emit('submit', this.value, doneWaiting);
    },
    cancel() {
      if (this.hasChildren) {
        this.state = 'pre';
      }
      this.$emit('cancel');
    }
  }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["InputPrompt"]
window._kiwi_exports.components.utils.InputPrompt = exports.default ? exports.default : exports;
